// Contador del banner de la promo (sections/skindion-promo-banner.liquid). Script clásico: la lógica pura vive en
// window.SkindionCountdown para probarla en Node (tools/promo-fold.test.mjs).
// Cuenta hacia una fecha FIJA (ajuste del theme, hora de CDMX), igual para todas las visitantes.
(() => {
  const logic = (window.SkindionCountdown = window.SkindionCountdown || {
    /**
     * «AAAA-MM-DD HH:MM» en hora de CDMX → milisegundos UTC; null si falta o no es una fecha real.
     * CDMX está en UTC−6 todo el año (sin horario de verano desde 2022).
     */
    parseEnd(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(String(value ?? '').trim());
      if (!match) return null;
      const [year, month, day, hour, minute] = match.slice(1).map(Number);
      if (month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59) return null;
      // Descarta días que no existen (31 de noviembre, 30 de febrero).
      if (new Date(Date.UTC(year, month - 1, day)).getUTCDate() !== day) return null;
      return Date.UTC(year, month - 1, day, hour + 6, minute);
    },
    /** Días, horas, minutos y segundos que faltan; null si no hay fecha o ya pasó. */
    remaining(endMs, nowMs) {
      if (endMs == null || endMs - nowMs <= 0) return null;
      const total = Math.floor((endMs - nowMs) / 1000);
      return {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
    },
  });

  if (typeof customElements === 'undefined' || customElements.get('skindion-promo-banner')) return;

  const pad = (n) => String(n).padStart(2, '0');

  class SkindionPromoBanner extends HTMLElement {
    #timer = 0;

    connectedCallback() {
      const end = logic.parseEnd(this.dataset.end);
      const box = this.querySelector('[data-timer]');
      const text = this.querySelector('[data-timer-text]');
      if (!box || end == null) return;

      let lastMinute = -1;
      const tick = () => {
        const left = logic.remaining(end, Date.now());
        if (!left) {
          box.hidden = true;
          this.disconnectedCallback();
          return;
        }
        for (const [unit, value] of Object.entries(left)) {
          const el = box.querySelector(`[data-unit="${unit}"]`);
          if (el) el.textContent = pad(value);
        }
        // Para lector de pantalla basta el minuto (role="timer" no se anuncia solo).
        if (text && left.minutes !== lastMinute) {
          lastMinute = left.minutes;
          text.textContent = `${left.days} días, ${left.hours} horas y ${left.minutes} minutos`;
        }
        box.hidden = false;
      };
      tick();
      this.#timer = window.setInterval(tick, 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.#timer);
      this.#timer = 0;
    }
  }

  customElements.define('skindion-promo-banner', SkindionPromoBanner);
})();
